import { useEffect } from 'react';
import $checkout from '@flittpayments/js-sdk';

export const useFlittFormWidget = ({ token = '', element, params, onSuccess, onError } = {}) => {
  useEffect(() => {
    const initFlittWidget = () => {
      if (!token) return () => {};

      const checkout = $checkout('FormWidget', {
        element: element,
        ...params,
      });

      // on second render we need to initialize form again;
      checkout.initElement(element);

      checkout.on('success', onSuccess);
      checkout.on('error', onError);
      return () => {
        checkout.off('success', onSuccess);
        checkout.off('error', onError);
        checkout.destroy();
      };
    };
    return initFlittWidget();
  }, [token]);
};
